/**
 * Shared Components
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import { initGlobalModal } from './Modal';
import * as youtubePlayer from '../utils/youtubePlayer';
import * as vimeoPlayer from '../utils/vimeoPlayer';
import * as videoUtils from '../utils/videoUtils';
import { waitForSharedComponents } from '@utils/waitForSharedComponents';
import { isMobile } from '@utils/matchMedia';
import pizzaLeft from '@assets/pizza_left.png';
import pizzaRight from '@assets/pizza_right.png';


window.SharedComponents = window.SharedComponents || {};
window.SharedComponents.modalManager = initGlobalModal();
window.SharedComponents.React = React;
window.SharedComponents.ReactDOM = ReactDOM;
window.SharedComponents.youtubePlayer = youtubePlayer;
window.SharedComponents.vimeoPlayer = vimeoPlayer;
window.SharedComponents.videoUtils = videoUtils;

document.addEventListener('DOMContentLoaded', () => onDOMReady());

async function onDOMReady() {

    await initYoutubeModalPlayers();

    initBackgroundImage();

}


function initBackgroundImage() {
    const mediaRow = document.getElementById('media');

    if (!mediaRow || isMobile()) {
        return;
    }

    const bgRight = document.createElement('div');
    bgRight.className = 'bg-image bg-image-right';
    bgRight.style.backgroundImage = `url(${pizzaRight})`;


    const bgLeft = document.createElement('div');
    bgLeft.className = 'bg-image bg-image-left';
    bgLeft.style.backgroundImage = `url(${pizzaLeft})`;


    mediaRow.appendChild(bgRight);
    mediaRow.appendChild(bgLeft);


    // Parallax scroll effect
    let ticking = false;

    window.addEventListener('scroll', () => {
        if (!ticking) {
            window.requestAnimationFrame(() => {
                const scrolled = window.pageYOffset;
                const parallaxSpeed = 0.1;
                
                bgRight.style.transform = `translateY(${scrolled * parallaxSpeed}px)`;
                bgLeft.style.transform = `translateY(-${scrolled * parallaxSpeed}px)`;
                
                ticking = false;
            });
            ticking = true;
        }
    });
}

async function initYoutubeModalPlayers() {

    try {
        await waitForSharedComponents();

        const { modalManager } = window.SharedComponents;

        const mediaItems = document.body.querySelectorAll('.media-play-button');
        if (mediaItems.length === 0) {
            return;
        }

        const handleMediaClick = (e) => {
            e.preventDefault();
            let link = e.currentTarget;
             if(link.tagName !== 'A') {
                link = link.querySelector('a');
            }
            const url = link?.href;
            if (!url || url === '#' || url === `${window.location.origin}/#`) {
                return;
            }

            let playerControls = null;
            modalManager.open({
                content: `<div class="video-container"><div id="video-player"></div></div>`,
                size: 'large',
                closeOnOverlay: false,
                onOpen: async () => {
                    try {
                        const { youtubePlayer } = window.SharedComponents;
                        playerControls = await youtubePlayer.createYouTubePlayer(
                            'video-player',
                            url,
                            {
                                autoplay: true,
                                mute: false,
                                controls: true
                            }
                        );

                        //  playerControls.play();
                    } catch (error) {
                        console.error('Error initializing YouTube player:', error);
                    }

                },
                onClose: () => {
                    if (playerControls && typeof playerControls.destroy === 'function') {
                        try {
                            playerControls.destroy();
                        } catch (error) {
                            console.error('Error destroying YouTube player:', error);
                        }
                        playerControls = null;
                    }
                }
            });
        };

        mediaItems.forEach((item) => {
            item.addEventListener('click', handleMediaClick);
        });
    } catch (error) {
        console.error('Failed to initialize YouTube modal players:', error);
    }
}
